import useFetchApi, {
    FetchingStatus,
    isLoading,
} from 'hooks/useFetchApi/useFetchApi'
import usePosPayment from 'hooks/usePosPayment/usePosPayment'
import useTipsSetting from 'hooks/useTipsSetting/useTipsSetting'
import { PaymentSettingContract, TipsSettingContract } from 'models'
import { createContext, useContext, useEffect, useMemo } from 'react'
import { useSaleDependenciesContext } from './SaleDependenciesContext'
import posPaymentSettingService from 'Services/api/posPaymentSetting.service'

export interface IPosPaymentSettingContext {
    allPaymentSettings: PaymentSettingContract[]
    paymentSettings: PaymentSettingContract[]
    tipsSetting: TipsSettingContract
    isLoading: boolean
}

const PosPaymentSettingContext = createContext<IPosPaymentSettingContext>(
    {} as IPosPaymentSettingContext,
)
const APICONFIG = { showErrorToast: true }
export function PosPaymentSettingContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const { isReady } = useSaleDependenciesContext()
    const [
        paymentSettings = [],
        getPaymentSettings,
        status,
        ,
        resetStatus,
    ] = useFetchApi(posPaymentSettingService.getPosPaymentSettings, APICONFIG)
    const { getPosPaymentAvailable, validationPaymentSetting } = usePosPayment()
    // Tips
    const {
        getTipsSetting,
        tipsSetting,
        loading: tipLoading,
    } = useTipsSetting()

    const posPaymentSettings = useMemo(() => {
        return getPosPaymentAvailable(paymentSettings)
    }, [getPosPaymentAvailable, paymentSettings])

    useEffect(() => {
        getTipsSetting()
        getPaymentSettings()
    }, [getPaymentSettings, getTipsSetting])

    useEffect(() => {
        if (status === FetchingStatus.SUCCESS && isReady) {
            validationPaymentSetting(posPaymentSettings)
            resetStatus()
        }
    }, [
        resetStatus,
        isReady,
        posPaymentSettings,
        status,
        validationPaymentSetting,
    ])

    return (
        <PosPaymentSettingContext.Provider
            value={{
                allPaymentSettings: paymentSettings,
                paymentSettings: posPaymentSettings,
                tipsSetting,
                isLoading: isLoading([status]) || tipLoading,
            }}
        >
            {children}
        </PosPaymentSettingContext.Provider>
    )
}

export const usePosPaymentSettingContext = () =>
    useContext(PosPaymentSettingContext)

export default PosPaymentSettingContext
